import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=0726fd7c&scoped=true"
import script from "./approvalRecord.vue?vue&type=script&lang=js"
export * from "./approvalRecord.vue?vue&type=script&lang=js"
import style0 from "./approvalRecord.vue?vue&type=style&index=0&id=0726fd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0726fd7c",
  null
  
)

export default component.exports